export default __webpack_public_path__ + "static/media/notification.853b9eae.svg";